import {Component} from '@angular/core';
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'app-top-line',
  templateUrl: './top-line.component.html',
  styleUrls: ['./top-line.component.css']
})
export class TopLineComponent {

  constructor(private readonly cookieService: CookieService) {
  }

  openCorpLogin() {
    this.cookieService.set('corporate', null, 1, '/', null, null, "Strict");
    location.assign('/authorized');
  }
}
